import { Module } from "vuex";
import {
  getLoginUser,
  emailAuthenticate,
  userLogin,
  userLoginByPhone,
  userLogout,
  userRegister,
} from "@/api/user";
import {
  LoginUserVO,
  EmailCodeLoginRequest,
  PhoneLoginRequest,
  UserLoginRequest,
  UserRegisterRequest,
} from "@/types/user";

export interface UserState {
  loginUser: LoginUserVO | null;
  loading: boolean;
}

const userModule: Module<UserState, unknown> = {
  namespaced: true,
  state: () => ({
    loginUser: null,
    loading: false,
  }),
  getters: {
    isLogin(state) {
      return Boolean(state.loginUser?.id);
    },
    isAdmin(state) {
      return state.loginUser?.userRole === "admin";
    },
  },
  mutations: {
    setLoginUser(state, user: LoginUserVO | null) {
      state.loginUser = user;
    },
    setLoading(state, loading: boolean) {
      state.loading = loading;
    },
  },
  actions: {
    async fetchLoginUser({ commit }) {
      commit("setLoading", true);
      try {
        const user = await getLoginUser();
        commit("setLoginUser", user);
        return user;
      } catch (error) {
        commit("setLoginUser", null);
        return null;
      } finally {
        commit("setLoading", false);
      }
    },
    async login({ commit }, payload: UserLoginRequest) {
      const user = await userLogin(payload);
      commit("setLoginUser", user);
      return user;
    },
    async phoneLogin({ commit }, payload: PhoneLoginRequest) {
      const user = await userLoginByPhone(payload);
      commit("setLoginUser", user);
      return user;
    },
    async emailAuthenticate({ commit }, payload: EmailCodeLoginRequest) {
      const user = await emailAuthenticate(payload);
      commit("setLoginUser", user);
      return user;
    },
    async register(_, payload: UserRegisterRequest) {
      return userRegister(payload);
    },
    async logout({ commit }) {
      await userLogout();
      commit("setLoginUser", null);
    },
  },
};

export default userModule;
